import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import header_1 from '../../assets/images/svg/header/mail.svg';
import header_2 from '../../assets/images/svg/header/clock.svg';
import header_3 from '../../assets/images/svg/header/location.svg';
import header_4 from '../../assets/images/svg/header/Insta.svg';
import header_5 from '../../assets/images/svg/header/Twiter.svg';
import header_6 from '../../assets/images/svg/header/Pintrest.svg';
import header_7 from '../../assets/images/Logo.svg';
import header_8 from '../../assets/images/svg/header/Search.svg';
import header_Logo from '../../assets/images/Logo.svg';
import header_footerLogo from '../../assets/images/footer-logo.svg';



const Header1 = () => {
    const [isFixed, setIsFixed] = useState(false);
    const [isSearchActive, setSearchActive] = useState(false);
    const [isMenuExpanded, setMenuExpanded] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);

    const handleScroll = () => {
        setIsFixed(window.scrollY > 50);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleSearchClick = () => {
        setSearchActive(true);
        document.body.classList.add('search-active');
    };

    const handleCloseSearch = () => {
        setSearchActive(false);
        document.body.classList.remove('search-active');
    };

    const toggleMenu = () => {
        setMenuExpanded(prevState => !prevState);
        document.body.classList.toggle('locked', !isMenuExpanded);
    };
    const toggleSideMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        document.body.classList.toggle("mobile-menu-open", !isMenuOpen);
    };
    const toggleDropdown = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };


    return (
        <>
            <div className="topbar-one">
                <div className="container-fluid">
                    <div className="topbar-one-inner">
                        <ul className="topbar-left-one">
                            <li>
                                <img src={header_1} alt="icon" />
                                <Link to="mailto:needhelp@company.com">needhelp@company.com</Link>
                            </li>
                            <li>
                                <img src={header_2} alt="icon" />
                                <p>Mon - Sat 8:00 AM - 6:00 PM</p>
                            </li>
                            <li>
                                <img src={header_3} alt="icon" />
                                <p>135 klf, Hotland, USA</p>
                            </li>
                        </ul>
                        <div className="topbar-right-one">
                            <ul className="topbar-link-right-one">
                                <li>
                                    <Link to="#">Login</Link>
                                </li>
                                <li>
                                    <Link to="#">Company News</Link>
                                </li>
                                <li>
                                    <Link to="#">FAQs</Link>
                                </li>
                            </ul>
                            <ul className="topbar-social-media-one">
                                <li>
                                    <Link to="https://www.instagram.com/">
                                        <img src={header_4} alt="icon" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://www.facebook.com/">
                                        <i className="fa-brands fa-facebook-f" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://x.com/">
                                        <img src={header_5} alt="icon" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://www.pinterest.com/">
                                        <img src={header_6} alt="icon" />
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <header className={isFixed ? "sticky-header--cloned sticky-fixed" : 'main-header'}>
                <div className="container-fluid">
                    <nav className="main-menu">
                        <div className="main-menu-logo">
                            <Link to="/">
                                <img src={header_7} alt="header-logo" />
                            </Link>
                        </div>
                        <div className="main-menu-inner">

                            <ul className="main-menu-list">
                                <li className="menu-item-children active">
                                    <Link to="#">Home</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li><Link to="/">Home One</Link></li>
                                        <li><Link to="/HomeTwo">Home Two</Link></li>
                                        <li><Link to="/HomeThree">Home Three</Link></li>
                                        <li><Link to="/HomeFour">Home Four</Link></li>
                                        <li><Link to="/HomeFive">Home Five</Link></li>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="#">Pages</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li><Link to="/Aboutus">About Us</Link></li>
                                        <li><Link to="/Careers">Careers</Link></li>
                                        <li><Link to="/Team">Meet The Team</Link></li>
                                        <li><Link to="/Testimonial">Testimonial</Link></li>
                                        <li><Link to="/Pricing">Pricing</Link></li>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="#">Services</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li><Link to="/Services">Services</Link></li>
                                        <li><Link to="/ServiceDetails">Services Details</Link></li>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="#">Portfolio</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li><Link to="/Portfolio">Portfolio</Link></li>
                                        <li><Link to="/Details">Portfolio Details</Link></li>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="#">Blog</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li><Link to="/Blog">Blog Standard</Link></li>
                                        <li><Link to="/BlogDetails">Blog Details</Link></li>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="#">Shop</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li><Link to="/Shop">Shop</Link></li>
                                        <li><Link to="/ProdectDetails">Product Details</Link></li>
                                        <li><Link to="/Cart">Cart</Link></li>
                                        <li><Link to="/CheckOut">Checkout</Link></li>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="/Contact">Contact Us</Link>
                                </li>
                            </ul>
                            <div className="header-menu-collaps" onClick={toggleSideMenu}>
                                <span className="line-1" />
                                <span className="line-2" />
                                <span className="line-3" />
                            </div>
                            <div className={`mobile-nav-wrapper ${isMenuOpen ? "expanded" : ""}`}>

                                <div className="mobile-nav-overlay" onClick={toggleSideMenu}></div>
                                <div className="mobile-nav-content">
                                    <button className="mobile-nav-close" onClick={toggleSideMenu} style={{ background: "none", fontSize: 50, border: "none", position: "fixed", top: 10, color: "#fff" }}>
                                        ×
                                    </button>
                                    <div className="logo-box">
                                        <Link to="/">
                                            <img width="150" src={header_Logo} alt="logo" />
                                        </Link>
                                    </div>
                                    <div className="mobile-nav-container">
                                        <ul className="mobile-menu-list">

                                            <li className={`menu-item-has-children ${openDropdown === 1 ? "dropdown-open" : ""}`}>

                                                <Link to="#" onClick={() => toggleDropdown(1)}>Home  <i className="fa-solid fa-chevron-down" /></Link>

                                                {openDropdown === 1 && (
                                                    <ul>
                                                        <li><Link to="/">Home-1</Link></li>
                                                        <li><Link to="/HomeTwo">Home-2</Link></li>
                                                        <li><Link to="/HomeThree">Home-3</Link></li>
                                                        <li><Link to="/HomeFour">Home-4</Link></li>
                                                        <li><Link to="/HomeFive">Home-5</Link></li>
                                                    </ul>
                                                )}
                                            </li>
                                            <li className={`menu-item-has-children ${openDropdown === 2 ? "dropdown-open" : ""}`}>
                                                <Link to="#" onClick={() => toggleDropdown(2)}>Pages  <i className="fa-solid fa-chevron-down" /></Link>
                                                {openDropdown === 2 && (
                                                    <ul>
                                                        <li><Link to="/Aboutus">About Us</Link></li>
                                                        <li><Link to="/Careers">Careers</Link></li>
                                                        <li><Link to="/Team">Meet The Team</Link></li>
                                                        <li><Link to="/Testimonial">Testimonial</Link></li>
                                                        <li><Link to="/Pricing">Pricing</Link></li>
                                                    </ul>
                                                )}
                                            </li>
                                            <li className={`menu-item-has-children ${openDropdown === 3 ? "dropdown-open" : ""}`}>
                                                <Link to="#" onClick={() => toggleDropdown(3)}>Services  <i className="fa-solid fa-chevron-down" /></Link>
                                                {openDropdown === 3 && (
                                                    <ul>
                                                        <li><Link to="/Services">Services</Link></li>
                                                        <li><Link to="/ServiceDetails">Service Details</Link></li>
                                                    </ul>
                                                )}
                                            </li>
                                            <li className={`menu-item-has-children ${openDropdown === 4 ? "dropdown-open" : ""}`}>
                                                <Link to="#" onClick={() => toggleDropdown(4)}>Portfolio  <i className="fa-solid fa-chevron-down" /></Link>
                                                {openDropdown === 4 && (
                                                    <ul>
                                                        <li><Link to="/Portfolio">Portfolio</Link></li>
                                                        <li><Link to="/Details">Portfolio Details</Link></li>
                                                    </ul>
                                                )}
                                            </li>
                                            <li className={`menu-item-has-children ${openDropdown === 5 ? "dropdown-open" : ""}`}>
                                                <Link to="#" onClick={() => toggleDropdown(5)}>Blog  <i className="fa-solid fa-chevron-down" /></Link>
                                                {openDropdown === 5 && (
                                                    <ul>
                                                        <li><Link to="/Blog">Blog Standard</Link></li>
                                                        <li><Link to="/BlogDetails">Blog Details  <i className="fa-solid fa-chevron-down" /></Link></li>
                                                    </ul>
                                                )}
                                            </li>
                                            <li className={`menu-item-has-children ${openDropdown === 6 ? "dropdown-open" : ""}`}>
                                                <Link to="#" onClick={() => toggleDropdown(6)}>Shop <i className="fa-solid fa-chevron-down" /></Link>
                                                {openDropdown === 6 && (
                                                    <ul>
                                                        <li><Link to="/Shop">Shop</Link></li>
                                                        <li><Link to="/ProductDetails">Product Details</Link></li>
                                                        <li><Link to="/Cart">Cart</Link></li>
                                                        <li><Link to="/Checkout">Checkout</Link></li>
                                                    </ul>
                                                )}
                                            </li>
                                            <li>
                                                <Link to="/Contact">Contact Us</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="main-menu-right">
                                <Link to="/Contact" className="btn btn-light btn-theme">
                                    Get In Touch +
                                </Link>
                                <Link className="search-btn" onClick={handleSearchClick}>
                                    <img src={header_8} alt="icon" />
                                </Link>

                                <div className={`search-popup ${isSearchActive ? 'active' : ''}`}>
                                    <button className="close-search" onClick={handleCloseSearch}></button>
                                    <form method="post" action="/Blog">
                                        <div className="form-group">
                                            <input
                                                type="search"
                                                name="search"
                                                placeholder="Search Here"
                                                required
                                            />
                                            <button type="submit">
                                                <i className="fa-solid fa-magnifying-glass"></i>
                                            </button>
                                        </div>
                                    </form>
                                </div>

                                <div className="header-side-menu" onClick={toggleMenu}>
                                    <span className="line-1" />
                                    <span className="line-2" />
                                </div>

                                <div className={`side-menu-wrapper ${isMenuExpanded ? 'expanded' : ''}`}>
                                    <div
                                        className={`side-menu-overlay ${isMenuExpanded ? 'expanded' : ''}`}
                                        onClick={toggleMenu}
                                    ></div>

                                    <div className={`side-menu-content ${isMenuExpanded ? 'expanded' : ''}`}>
                                        <Link to="" className="side-menu-toggler" onClick={toggleMenu}>
                                            <span></span>
                                            <span></span>
                                        </Link>
                                        <div className="side-menu-logo-box">
                                            <Link to="/">
                                                <img src={header_footerLogo} alt="logo" />
                                            </Link>
                                        </div>
                                        <div className="side-menu-container">
                                            <p>
                                                Uniqo - Business Consulting WordPress Theme for professionals, services, and solutions.
                                            </p>
                                            <h4>Contact Info</h4>
                                            <ul>
                                                <li><span>Mon - Fri: 8:00 - 16:00</span></li>
                                                <li><Link to="mailto:help@company.com">help@company.com</Link></li>
                                                <li><Link to="tel:+12009845611">+120.098.456 11</Link></li>
                                            </ul>
                                            <h4>Office Address</h4>
                                            <p>28 Valencia Street, New York, United States of America</p>
                                            <ul className="side-menu-social-media">
                                                <li><Link to="https://www.facebook.com/"><i className="fa-brands fa-facebook-f"></i></Link></li>
                                                <li><Link to="https://x.com/"><i className="fa-brands fa-twitter"></i></Link></li>
                                                <li><Link to="https://www.instagram.com/"><i className="fa-brands fa-instagram"></i></Link></li>
                                                <li><Link to="https://in.linkedin.com/"><i className="fa-brands fa-linkedin-in"></i></Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
        </>
    );
};

export default Header1;